module.exports = __webpack_public_path__ + "img/武汉大学.5c9e1eca.png";